module.exports = new __parcel__URL__("troops_mercenary.0a1b0dd8.png").toString();